import { FormulierSamenvatting, KlantcontactBevestiging } from '@cak-legacy/klantondersteuning-client';
import { ISubmitFormulierResult } from '../interfaces/submit-formulier-results';

export class ResponseMapperFormulier {
  map = (response: KlantcontactBevestiging): ISubmitFormulierResult => {
    return {
      klantcontactnummer: response.klantcontactnummer || 0,
      bericht: response.bericht || '',
      formulierSamenvatting: new FormulierSamenvatting({
        bestandsnaam: response.formulierSamenvatting?.bestandsnaam || '',
        base64Inhoud: response.formulierSamenvatting?.base64Inhoud || '',
      }),
    };
  };
}
